export default class RegisterForm {

  constructor () {
    this.form = document.getElementById('register-form')
    this.form && setTimeout(() => this.init(), 1)
  }

  init () {
    this.companySwitch = this.form.elements['is_company']
    this.companyField = this.form.querySelector('.form-group--company');
    this.vatIdField = this.form.querySelector('.form-group--vat_id');
    this.vatField = this.form.querySelector('.form-group--vat');

    this.toggleCompany(this.companySwitch.value === "1")

    for (let radio of this.companySwitch) {
      radio.addEventListener('change', () => {
         this.toggleCompany(this.companySwitch.value === "1")
      })
    }
  }

  toggleCompany (on) {
    on
      ? this.companyField.classList.remove('d-none')
      : this.companyField.classList.add('d-none')

    on
      ? this.vatIdField.classList.remove('d-none')
      : this.vatIdField.classList.add('d-none')
    
    on
      ? this.vatField.classList.remove('d-none')
      : this.vatField.classList.add('d-none')
  }
}
